/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ISocialsBlockData } from './socials-block.data';
import { alignment, facebookToggle, instagramToggle, twitterToggle, ISocialsBlockProps } from './socials-block.props.autogenerated';

export interface ISocialsBlockViewProps extends ISocialsBlockProps<ISocialsBlockData> {
    linkFB: string;
    toggleFB: facebookToggle;
    logoFB: string;
    linkIG: string;
    toggleIG: instagramToggle;
    logoIG: string;
    linkT: string;
    toggleT: twitterToggle;
    logoT: string;
    align: alignment;
}

/**
 *
 * SocialsBlock component
 * @extends {React.PureComponent<ISocialsBlockProps<ISocialsBlockData>>}
 */
class SocialsBlock extends React.PureComponent<ISocialsBlockProps<ISocialsBlockData>> {
    public render(): JSX.Element | null {
        const SocialsBlockViewProps = {
            ...this.props,
            linkFB: this.props.config.facebookLink ? this.props.config.facebookLink : '',
            toggleFB: this.props.config.facebookToggle,
            logoFB: this.props.config.facebookLogo ? this.props.config.facebookLogo.src : '',
            linkIG: this.props.config.instagramLink ? this.props.config.instagramLink : '',
            toggleIG: this.props.config.instagramToggle,
            logoIG: this.props.config.instagramLogo ? this.props.config.instagramLogo.src : '',
            linkT: this.props.config.twitterLink ? this.props.config.twitterLink : '',
            toggleT: this.props.config.twitterToggle,
            logoT: this.props.config.twitterLogo ? this.props.config.twitterLogo.src : '',
            align: this.props.config.alignment
        }

        return this.props.renderView(SocialsBlockViewProps);
    }
}

export default SocialsBlock;
